// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9biCD","left":"styles_left__NtgRF","desktopActions":"styles_desktopActions__2zm9C","title":"styles_title__X80e7"};